export { default } from './EzAutocomplete.vue';
